// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__1jJwR","field":"LoginForm_field__0UB0j","input":"LoginForm_input__ShV3m"};